import './winmock8/style';
import FormStructure from './winmock8/form_structure';

export default FormStructure;